import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@emotion/react'
import { CourseThemeListItemServerResponse } from '@models/courseTheme'
import { ProgressStatuses } from '@enums/ProgressStatuses'
import Accordion, { AccordionHeaderProps, AccordionBodyProps } from '@organisms/Accordion'
import Text from '@organisms/Text'
import FlexWrapper from '@organisms/FlexWrapper'
import Badge from '@organisms/Badge'
import getThemeRoute from '@utils/getThemeRoute'
import manyWords from '@utils/manyWords'
import {
  HeaderWrapper,
  RightWrapper as HeaderRightWrapper,
  Square,
  TagsWrapper,
  ThemeTitle,
} from '../Chapter/styled'
import { Number, RightWrapper, Wrapper } from '../Chapter/Body/Theme/styled'

const FINAL_TEST_LABEL = 'Итоговое тестирование'

type BodyProps = AccordionBodyProps & {
  finalTest: CourseThemeListItemServerResponse
  number: number
  courseId: string | number
  educationId: string | number
}

const FinalTestBody: FC<BodyProps> = ({ finalTest, number, courseId, educationId, onChangeSize, toggleLoading }) => {
  const navigate = useNavigate()
  const {
    colors: { warning, success, disable },
  } = useTheme()

  useEffect(() => {
    toggleLoading(false)
    onChangeSize()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const courseIri = '/api/courses/' + courseId
  const status = finalTest.currentListenerStatus

  // Как у обычных тем: серый — не начато, жёлтый — только в процессе (после
  // первого входа), зелёный — пройдено. До входа итоговое НЕ должно быть жёлтым.
  const badgeColor = !status
    ? disable
    : status === ProgressStatuses.PASSED
    ? success
    : status === ProgressStatuses.IN_PROCESS
    ? warning
    : disable

  const handleClick = () => {
    navigate(getThemeRoute(finalTest.id, courseIri, educationId))
  }

  return (
    <Wrapper onClick={handleClick}>
      <FlexWrapper>
        <Number>{number}.1</Number>
        {FINAL_TEST_LABEL}
      </FlexWrapper>
      <RightWrapper>
        <Badge badgeColor={badgeColor} />
      </RightWrapper>
    </Wrapper>
  )
}

type Props = {
  finalTest: CourseThemeListItemServerResponse
  number: number
  courseId: string | number
  educationId: string | number
}

const FinalTestChapter: FC<Props> = ({ finalTest, number, courseId, educationId }) => {
  const hoursCount = finalTest.hoursTime ? Math.round(finalTest.hoursTime / 60) : 0

  const header: FC<AccordionHeaderProps> = ({ hovered, expanded }) => (
    <HeaderWrapper>
      <Square active={expanded || hovered}>{number}</Square>
      <HeaderRightWrapper>
        <ThemeTitle hovered={hovered}>{FINAL_TEST_LABEL}</ThemeTitle>
        {hoursCount > 0 && (
          <TagsWrapper>
            <Text type="tag">
              {manyWords(hoursCount, 'час', 'часа', 'часов')}
            </Text>
          </TagsWrapper>
        )}
      </HeaderRightWrapper>
    </HeaderWrapper>
  )

  return (
    <Accordion
      id="final-test-chapter"
      skeletonHeight={105}
      Header={header}
      Body={({ onChangeSize, toggleLoading }) => (
        <FinalTestBody
          finalTest={finalTest}
          number={number}
          courseId={courseId}
          educationId={educationId}
          onChangeSize={onChangeSize}
          toggleLoading={toggleLoading}
        />
      )}
    />
  )
}

export default FinalTestChapter
